export const ExternalLinkDefaultIcon: React.FC<React.ComponentProps<"svg">> = ({
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 6.5097C4.73478 6.5097 4.48043 6.61506 4.29289 6.8026C4.10536 6.99013 4 7.24449 4 7.5097V18.5097C4 18.7749 4.10536 19.0293 4.29289 19.2168C4.48043 19.4043 4.73478 19.5097 5 19.5097H16C16.2652 19.5097 16.5196 19.4043 16.7071 19.2168C16.8946 19.0293 17 18.7749 17 18.5097V12.5097C17 11.9574 17.4477 11.5097 18 11.5097C18.5523 11.5097 19 11.9574 19 12.5097V18.5097C19 19.3054 18.6839 20.0684 18.1213 20.631C17.5587 21.1936 16.7957 21.5097 16 21.5097H5C4.20435 21.5097 3.44129 21.1936 2.87868 20.631C2.31607 20.0684 2 19.3054 2 18.5097V7.5097C2 6.71406 2.31607 5.95099 2.87868 5.38838C3.44129 4.82577 4.20435 4.5097 5 4.5097H11C11.5523 4.5097 12 4.95742 12 5.5097C12 6.06199 11.5523 6.5097 11 6.5097H5Z"
        fill="currentColor"
      />
      <path
        d="M15 1.5097C14.4477 1.5097 14 1.95742 14 2.5097C14 3.06199 14.4477 3.5097 15 3.5097H18.5858L9.29289 12.8026C8.90237 13.1931 8.90237 13.8263 9.29289 14.2168C9.68342 14.6073 10.3166 14.6073 10.7071 14.2168L20 4.92392V8.5097C20 9.06199 20.4477 9.5097 21 9.5097C21.5523 9.5097 22 9.06199 22 8.5097V2.5097C22 1.95742 21.5523 1.5097 21 1.5097H15Z"
        fill="currentColor"
      />
    </svg>
  );
};
